import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import SensorThChart from "../components/SensorThChart";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next"; // Aggiungi l'importazione

const SensorThChartPage = () => {
    const { t } = useTranslation("global"); // Inizializza il hook di traduzione
    const { auth } = useAuth();
    const { sensorId } = useParams(); // Ottieni l'ID del sensore dai parametri dell'URL
    const [sensorData, setSensorData] = useState([]);
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        if (!auth?.accessToken) {
            return;
        }
        
        // Recupera i dati giornalieri del sensore
        const fetchSensorData = async () => {
            try {
                const response = await axiosPrivate.get(`/sensors/${sensorId}/daily`);
                setSensorData(response.data);
            } catch (error) {
                console.error(t('sensors.errors.dataFetch', "Errore nel recupero dei dati del sensore:"), error);
            }
        };

        fetchSensorData();
    }, [sensorId, t, axiosPrivate, auth?.accessToken]);

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                {t('sensors.chart.title', "Dati Sensore {{id}}", { id: sensorId })}
            </Typography>
            <Box sx={{ mt: 2 }}>
                <SensorThChart sensorId={sensorId} data={sensorData} />
            </Box>
        </Box>
    );
};

export default SensorThChartPage;